import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75b9643d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "digits" }, ":", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "digits" }, ":", -1))

import { Timespending } from '@/app.context/workspace/Event';
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import { TimeSegment } from '@/logic/_infra/time';
import { offset as offset_f } from '@/components/Workspaces/persons/_spec/timeline/clock_timeline'



import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { computed } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TimesegmentComponent',
  props: {
    segment: {},
    offset: {},
    stopPropagation: { type: Boolean }
  },
  emits: {
    "click"(d: Direction, e: SegmentEnd) {

        return true
    }
},
  setup(__props: any, { emit: __emit }) {


const props = __props

// const emit = defineEmits({
//     "click"(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

//         return true
//     }
// })


const a = computed(() => dayjs(props.segment.timepoint).utcOffset(offset.value))

const b = computed(() => dayjs(props.segment.end()).utcOffset(offset.value))


const emit = __emit

function click(event: Event, d: Direction, e: SegmentEnd) {

    if (props.stopPropagation ?? false) event.stopPropagation()

    emit("click", d, e)
}

const offset = offset_f(props)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("span", {
      class: "clickable digits",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (click($event, "B", "S")))
    }, _toDisplayString(a.value.format("HH")), 1),
    _hoisted_1,
    _createElementVNode("span", {
      class: "clickable digits",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (click($event, "F", "S")))
    }, _toDisplayString(a.value.format("mm")), 1),
    _hoisted_2,
    _createElementVNode("span", {
      class: "clickable digits",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (click($event, "B", "E")))
    }, _toDisplayString(b.value.format("HH")), 1),
    _hoisted_3,
    _createElementVNode("span", {
      class: "clickable digits",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (click($event, "F", "E")))
    }, _toDisplayString(b.value.format("mm")), 1)
  ]))
}
}

})